import * as ActionTypes from './index';

export function setTellerOverviewActiveTab(payload) {
    return {
        type: ActionTypes.SET_TELLER_OVERVIEW_ACTIVE_TAB,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/tellerOverview.js